// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default interface IComponentState<T = any>
{
    loading: boolean
    ready: boolean
    data?: T
}

export const ComponentStateDto: IComponentState = {
    loading: false,
    ready: false
}
export const ComponentStateLoadingDto: IComponentState = {
    loading: true,
    ready: false
}
export const ComponentStateReadyDto: IComponentState = {
    loading: false,
    ready: true
}